<template>
  <div class="pageContainer">
    <div class="topDiv backgroundCoverImageCenter">
      <h1 class="displayNone-sm">
        The World Needed A Place <br/>
        And We Saw The Oppurtunity
      </h1>
       <h1 class="displayBlockOn-sm">
        grab your bag
      </h1>
    </div>
    <div class="bottomDiv verticalMiddle">
    <div class="container">
        Nature has been generous with Kerala, a strip of picturesque land on the Southern Coast of India, has been under the world's magnifing glass throughout history.She drew people from all parts of the world since time immemorial. If you are ready to see the world outside your front door...grab your bag.
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index'/*,
  data () {
    return {}
  } */
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "~scssDir/_breakpoints.scss";
@import "~scssDir/_variables.scss";
@import "~scssDir/_myAnimations.scss";
.topDiv {
  height: 65vh;
  background-image: url("~images/index.jpg");
  h1 {
    color: $color4;
  }
}
.bottomDiv {
  min-height: 35vh;
  background-color: $color3;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue